const InitHasScrolled = () => {
  let didScroll;
  let lastScrollTop = 0;
  const delta = 5;
  const navbarHeight = 1000;

  const hasScrolled = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }
    if (st > lastScrollTop && st > navbarHeight) {
      console.log('scroll Down');
    } else if (
      st + window.innerHeight <
      document.documentElement.offsetHeight
    ) {
      console.log('scroll Up');
    }
    lastScrollTop = st;
  };
  window.addEventListener('scroll', () => {
    didScroll = true;
  });

  setInterval(() => {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  });
};
export default InitHasScrolled;
